import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { getElementName } from "qpr-base/tplutils/utils";
import React from "react";
import useFormStyles from "./KPIsForm/themes";
import FormikSelect from "./form/FormikSelect";

interface Props {
  index: number;
  label: string;
  name: string;
  elementType: string;
  handleFieldChange: any;
  topElementId: string;
  themeOptions?: any;
  priorityOptions?: any;
  sectorOptions?: any;
  clusterOptions?: any;
  disabled?: boolean;
}
const DubaiLinkSelect = ({
  index,
  label,
  name,
  handleFieldChange,
  topElementId,
  themeOptions,
  elementType,
  priorityOptions,
  clusterOptions,
  sectorOptions,
  ...props
}: Props) => {
  const ctx = useAppContext();

  const classes = useFormStyles();

  const getOptions = (): { title: string; value: any }[] => {
    if (elementType === "Perspective") {
      return (
        Object.keys(themeOptions)
          ?.filter((itm: any) => themeOptions[itm][0])
          .map((cur: any) => ({
            title: getElementName(themeOptions[cur][0], ctx.language),
            value: themeOptions[cur][0].symbol,
          })) || []
      );
    }
    if (elementType === "Strategic Objective") {
      return (
        Object.keys(priorityOptions)
          ?.filter((itm: any) => priorityOptions[itm][0])
          ?.map((cur: any) => ({
            title: getElementName(priorityOptions[cur][0], ctx.language),
            value: priorityOptions[cur][0].symbol,
          })) || []
      );
    }
    return [];
  };
  const options = getOptions();

  const handleChange = (value: string, field: string) => {
    handleFieldChange(value, field);
  };

  return (
    <div className={classes.flexRow}>
      <FormikSelect
        key={index}
        name={name}
        label={label}
        options={options}
        handleFieldChange={handleChange}
        disabled={!options.length || label === "Plan" || props.disabled}
      />
    </div>
  );
};

export default DubaiLinkSelect;
